import React from 'react';
import * as S from '../styles';
import { Box, Button } from '@mui/material';
import { ACTION_BLUE, ACTION_BLUE_HOVER } from '../../../theme/theme';

interface PropsApplicationEditNavbar {
  onSubmit: () => void;
}

const ApplicationEditNavbar: React.FC<PropsApplicationEditNavbar> = ({
  onSubmit,
}) => {
  return (
    // No card of its own: this is the page's heading row, so it sits directly
    // on the background above the form cards.
    <Box
      sx={{
        display: 'flex',
        // RTL row: the title comes first and lands on the right, the button
        // last and lands on the left.
        flexDirection: 'row',
        direction: 'rtl',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <S.Title as="div">{'ویرایش اطلاعات اپلیکیشن'}</S.Title>

      <Button
        variant="contained"
        type="button"
        onClick={onSubmit}
        sx={{
          backgroundColor: ACTION_BLUE,
          color: '#FFFFFF',
          textTransform: 'none',
          whiteSpace: 'nowrap',
          '&:hover': {
            backgroundColor: ACTION_BLUE_HOVER,
          },
        }}
      >
        {'ثبت تغییرات'}
      </Button>
    </Box>
  );
};

export default ApplicationEditNavbar;
